export enum NextRoleSection {
  availability = 'availability',
  workTypes = 'work-types',
  preferredLocations = 'preferred-locations',
  rightToWork = 'right-to-work',
  salary = 'salary',
  classification = 'classification',
  approachability = 'approachability',
}
